/**
 * Error thrown by `parse` for files it cannot (or, in strict mode, will not) read.
 */
export class SpcParserError extends Error {
    /**
     * Category of the failure.
     */
    code;
    /**
     * Creates a typed parser error.
     * @param code - category of the failure.
     * @param message - human-readable description.
     */
    constructor(code, message) {
        super(message);
        this.name = 'SpcParserError';
        this.code = code;
    }
}
//# sourceMappingURL=SpcParserError.js.map